export default {
  template: {},
  webviewerInstance: null,
  isUploadingTemplate: false,
};
